import { api } from '@kolab/dms-base/api'

/**
 * Lightweight picker endpoints. Each returns `{ items: LabelValuePair[] }`
 * — the BFF's picker controllers pass through nirixis's *ForPicker gRPC
 * methods, which each require a distinct `.pick` permission (see
 * `src/rbac/permissions.ts`).
 *
 * Why the split from the regular list endpoints: the pick permission is
 * granted to any role that needs to reference the entity from another page
 * (e.g. a Distributor Admin who onboards Resellers needs to `.pick`
 * distributors even though they cannot view the full Distributors admin
 * page). Splitting the endpoints lets us grant `.pick` without granting
 * `.list.view`.
 */

export interface LookupItem {
  id: string
  label: string
}

interface LookupList {
  items: LookupItem[]
}

const LOOKUPS = '/v1/lookups'

export async function pickDistributors(search?: string) {
  return api.get<LookupList>(`${LOOKUPS}/distributors`, { params: { search }, _suppressErrorToast: true }).then((r) => r.data)
}

export async function pickResellers(params?: { search?: string; distributorId?: string }) {
  return api.get<LookupList>(`${LOOKUPS}/resellers`, { params, _suppressErrorToast: true }).then((r) => r.data)
}

export async function pickLicenseProducts(search?: string) {
  return api.get<LookupList>(`${LOOKUPS}/license-products`, { params: { search }, _suppressErrorToast: true }).then((r) => r.data)
}

export async function pickDistributorLicenses(distributorId?: string) {
  return api
    .get<LookupList>(`${LOOKUPS}/distributor-licenses`, { params: { distributorId }, _suppressErrorToast: true })
    .then((r) => r.data)
}

export async function pickRoles(search?: string) {
  return api.get<LookupList>(`${LOOKUPS}/roles`, { params: { search }, _suppressErrorToast: true }).then((r) => r.data)
}
